/* Single pass per line: the tag scan and the attribute scan never look at
   already-emitted tokens, so an attribute pass can never match its own output. */

export type XmlTokenKind = "com" | "tag" | "attr" | "val" | "txt";
export type XmlToken = { kind: XmlTokenKind; text: string };
export type XmlLine = { tokens: XmlToken[] };

const TAG = /<!--[\s\S]*?-->|<\/?[A-Za-z_?][\w:.?-]*(?:\s[^<>]*?)?\/?>/g;
const ATTR = /([\w:.-]+)\s*=\s*"([^"]*)"/g;
const PARTS = /^(<[/?]?)([\w:.?-]+)([\s\S]*?)([?/]?>)$/;

export function xmlTokenize(src: string): XmlLine[] {
  return src.split("\n").map((line) => {
    const tokens: XmlToken[] = [];
    const push = (kind: XmlTokenKind, text: string) => {
      if (text) tokens.push({ kind, text });
    };

    let cursor = 0;
    let m: RegExpExecArray | null;
    TAG.lastIndex = 0;
    while ((m = TAG.exec(line)) !== null) {
      if (m.index > cursor) push("txt", line.slice(cursor, m.index));
      const tag = m[0];
      if (tag.startsWith("<!--")) {
        push("com", tag);
      } else {
        const t = PARTS.exec(tag);
        if (!t) {
          push("txt", tag);
        } else {
          const [, opener = "", name = "", attrRun = "", closer = ""] = t;
          push("txt", opener);
          push("tag", name);
          let j = 0;
          let a: RegExpExecArray | null;
          ATTR.lastIndex = 0;
          while ((a = ATTR.exec(attrRun)) !== null) {
            const [whole, key = "", val = ""] = a;
            if (a.index > j) push("txt", attrRun.slice(j, a.index));
            push("attr", key);
            push("txt", whole.slice(key.length, whole.length - val.length - 2));
            push("val", `"${val}"`);
            j = a.index + whole.length;
          }
          push("txt", attrRun.slice(j));
          push("txt", closer);
        }
      }
      cursor = m.index + tag.length;
    }
    if (cursor < line.length) push("txt", line.slice(cursor));
    return { tokens };
  });
}
